import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { FiEye, FiEyeOff, FiRefreshCw } from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";
import { makeRequest } from "../../_config/api";

export default function Login() {
  const [admin, setAdmin] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAdmin((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!admin.username.trim() || !admin.password) {
      showErrorToast("username and password are required");
      return;
    }

    setLoading(true);

    try {
      const { data, error, message } = await makeRequest(
        "post",
        "/admin/adminLogin",
        {
          userName: admin.username,
          password: admin.password,
        }
      );
      if (error) {
        showErrorToast(message || "Login failed");
        return;
      }

      showSuccessToast("Login successful");

      const userData = {
        role: data.role,
        leader: data.leader,
        accessPages: data.accessPages,
        token: data.token,
        userId: data.userId,
      };

      sessionStorage.setItem("user", JSON.stringify(userData));

      navigate("/");
    } catch (error) {
      console.error("Login failed:", error);
      showErrorToast(error.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center
                 bg-[#F8FAFC] dark:bg-[#121212] p-4 transition-all"
    >
      <ToastContainer />

      {/* Card */}
      <div className="max-w-md w-full bg-white
  border border-[#E2E8F0]
  rounded-2xl shadow-xl p-6"
      >

        <div className="text-center mb-6">
          <h1 className="text-4xl font-bold text-[#1E293B]">
            Admin Dashboard
          </h1>

          <p className="text-sm text-[#6B6B6B] dark:text-[#BFBFBF] mt-1">
            Sign in to your account
          </p>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {/* Email */}
          <div>
            <label className="block text-sm font-medium text-[#434646] dark:text-white mb-1">
              Username
            </label>
            <input
              type="text"
              name="username"
              value={admin.username}
              onChange={handleInputChange}
              placeholder="Enter username"
              className="w-full px-4 py-2 rounded-lg border
                         border-[#DADACD] dark:border-[#2D2D2D]
                         bg-white dark:bg-[#121212]
                         text-[#434646] dark:text-white
                         focus:outline-none focus:ring-2 focus:ring-[#749EED]"
            />
          </div>

          {/* Password */}
          <div className="relative">
            <label className="block text-sm font-medium text-[#434646] dark:text-white mb-1">
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={admin.password}
              onChange={handleInputChange}
              placeholder="Enter password"
              className="w-full px-4 py-2 rounded-lg border
                         border-[#DADACD] dark:border-[#2D2D2D]
                         bg-white dark:bg-[#121212]
                         text-[#434646] dark:text-white
                         focus:outline-none focus:ring-2 focus:ring-[#749EED]
                         pr-10"
            />

            <div
              className="absolute inset-y-0 right-0 top-6 pr-3 flex items-center cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FiEyeOff className="text-[#4A9CF0]" />
              ) : (
                <FiEye className="text-[#4A9CF0]" />
              )}

            </div>
          </div>

          {/* Button */}
          <div>
            <button
              type="submit"
              disabled={loading}
              className={`w-full flex justify-center items-center rounded-lg
    px-4 py-2 text-white font-semibold transition
    ${loading
                  ? "bg-[#4A9CF0]/70 cursor-not-allowed"
                  : "bg-[#4A9CF0] hover:bg-[#2563EB]"
                }`}
            >

              {loading ? (
                <>
                  <FiRefreshCw className="animate-spin h-5 w-5 mr-2" />
                  Logging in...
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
